<template>
    <fieldset class="payment">
        <my-input
            v-if="amountDueMessage !== null"
            type="div"
            label="Total due"
            :input-class="['autoHeight']"
        >
            <div
                slot="custom"
                v-html="amountDueMessage"
            />
        </my-input>
        <my-input
            label="Payment type"
            :required="true"
        >
            <template v-slot:custom>
                <select v-model="paymentType">
                    <option value="tok_visa">Successful payment</option>
                    <option value="tok_visa_chargeDeclinedInsufficientFunds">Insufficient funds</option>
                    <option value="tok_visa_chargeDeclinedExpiredCard">Expired card</option>
                </select>
            </template>
        </my-input>
    </fieldset>
</template>

<script>
import MyInput from '../../_components/form/MyInput.vue';

export default {
    components: {
        MyInput,
    },

    props: {
        amountDueMessage: {
            type: String,
            default: null,
        },
    },

    data() {
        return {
            paymentType: 'tok_visa',
        };
    },

    methods: {
        getToken() {
            return Promise.resolve({token: {id: this.paymentType}});
        },

        touch() {
            // noop
        },
    },

    mounted() {
        this.$emit('validity', true);
    }
}
</script>

<style lang="scss">
</style>
